import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=0e05cfe2&scoped=true&"
import script from "./Dashboard.vue?vue&type=script&lang=js&"
export * from "./Dashboard.vue?vue&type=script&lang=js&"
import style0 from "@/assets/styles/beneficiary.css?vue&type=style&index=0&id=0e05cfe2&scoped=true&lang=css&"
import style1 from "@/assets/styles/webchat-style.scss?vue&type=style&index=1&lang=scss&"
import style2 from "./Dashboard.vue?vue&type=style&index=2&id=0e05cfe2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e05cfe2",
  null
  
)

export default component.exports